import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"
import _imports_0 from '@/app/ui/assets/svg/cod-logo-2.svg'
import _imports_1 from '@/app/ui/assets/svg/dfod-logo-2.svg'
import _imports_2 from '@/app/ui/assets/svg/trash_red.svg'


const _hoisted_1 = { class: "bg-white rounded-xl my-4 px-4" }
const _hoisted_2 = { class: "flex items-center justify-between py-3" }
const _hoisted_3 = { class: "text-gray-lp-300 text-xl font-semibold" }
const _hoisted_4 = { class: "py-4 border-t border-b border-gray-lp-900" }
const _hoisted_5 = { class: "w-full flex justify-between text-gray-lp-300" }
const _hoisted_6 = { class: "relative" }
const _hoisted_7 = { class: "text-sm mb-2" }
const _hoisted_8 = { class: "font-semibold" }
const _hoisted_9 = { class: "text-gray-lp-600 font-normal text-xs" }
const _hoisted_10 = {
  key: 1,
  class: "absolute left-0 top-full mt-2 w-72 bg-white border border-gray-200 rounded-xl shadow-xl z-50 max-h-60 overflow-auto"
}
const _hoisted_11 = { class: "font-medium text-sm" }
const _hoisted_12 = { class: "text-xs text-gray-500" }
const _hoisted_13 = { class: "text-sm mb-2" }
const _hoisted_14 = { class: "font-semibold text-lg" }
const _hoisted_15 = { class: "text-sm mb-2" }
const _hoisted_16 = { class: "font-semibold text-lg" }
const _hoisted_17 = { class: "text-sm mb-2" }
const _hoisted_18 = { class: "font-bold text-red-lp-300 text-xl" }
const _hoisted_19 = { class: "text-sm mb-1" }
const _hoisted_20 = { class: "grid grid-cols-2 gap-6 my-4" }
const _hoisted_21 = { class: "flex flex-col" }
const _hoisted_22 = { class: "text-sm text-gray-600 mb-2" }
const _hoisted_23 = { class: "text-gray-lp-600 font-normal" }
const _hoisted_24 = { class: "flex flex-col" }
const _hoisted_25 = { class: "flex gap-1" }
const _hoisted_26 = { class: "text-gray-lp-300 text-sm" }
const _hoisted_27 = {
  key: 0,
  src: _imports_0,
  class: "w-8",
  alt: "logo_cod"
}
const _hoisted_28 = {
  key: 1,
  src: _imports_1,
  class: "w-8",
  alt: "logo_dfod"
}
const _hoisted_29 = { class: "text-gray-lp-600 text-sm" }
const _hoisted_30 = { class: "flex flex-col" }
const _hoisted_31 = { class: "text-gray-lp-300 text-sm" }
const _hoisted_32 = { class: "text-gray-lp-600 text-sm" }
const _hoisted_33 = { class: "flex flex-col" }
const _hoisted_34 = { class: "text-gray-lp-300 text-sm" }
const _hoisted_35 = { class: "text-gray-lp-600 text-sm" }
const _hoisted_36 = { class: "flex flex-col" }
const _hoisted_37 = {
  key: 0,
  class: "text-gray-lp-300 text-sm"
}
const _hoisted_38 = {
  key: 1,
  class: "text-gray-lp-800 text-sm"
}
const _hoisted_39 = {
  key: 0,
  class: "text-red-lp-100"
}
const _hoisted_40 = {
  key: 1,
  class: "text-red-lp-100"
}
const _hoisted_41 = {
  key: 2,
  class: "text-red-lp-100 font-bold"
}
const _hoisted_42 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-5 h-5",
  alt: "delete_button"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Select = _resolveComponent("Select")!
  const _component_InvoiceRecipientTagPicker = _resolveComponent("InvoiceRecipientTagPicker")!
  const _component_TableBillDetail = _resolveComponent("TableBillDetail")!
  const _component_ModalSuccessReceipt = _resolveComponent("ModalSuccessReceipt")!
  const _component_InvoicePdfStruk = _resolveComponent("InvoicePdfStruk")!
  const _component_InvoicePdfA4 = _resolveComponent("InvoicePdfA4")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("section", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t("tagihan.detailTitle")), 1),
        _createVNode(_component_LpButton, {
          textColor: "white",
          title: _ctx.buttonActionTitle,
          onClick: _ctx.onHandleSubmit,
          disabled: !_ctx.recipieNameValue
        }, null, 8, ["title", "onClick", "disabled"])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("tagihan.form.sender")), 1),
            _createVNode("p", _hoisted_8, [
              _createTextVNode(_toDisplayString(_ctx.sendersName[0]?.name) + " ", 1),
              _createVNode("span", _hoisted_9, _toDisplayString(_ctx.maskSensitiveData(_ctx.sendersName[0]?.phone)), 1)
            ]),
            (_ctx.sendersName.length > 1)
              ? (_openBlock(), _createBlock("button", {
                  key: 0,
                  class: "text-red-lp-300 text-sm font-medium underline mt-1",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleList && _ctx.toggleList(...args)))
                }, _toDisplayString(_ctx.showList
                ? _ctx.$t("tagihan.form.close")
                : _ctx.$t("tagihan.form.moreSenders", { n: _ctx.sendersName.length - 1 })), 1))
              : _createCommentVNode("", true),
            (_ctx.showList)
              ? (_openBlock(), _createBlock("div", _hoisted_10, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sendersName.slice(1), (item, index) => {
                    return (_openBlock(), _createBlock("div", {
                      key: index,
                      class: "px-4 py-3 hover:bg-gray-100"
                    }, [
                      _createVNode("span", _hoisted_11, _toDisplayString(item.name), 1),
                      _createVNode("span", _hoisted_12, " (" + _toDisplayString(_ctx.maskSensitiveData(item.phone)) + ") ", 1)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", null, [
            _createVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("tagihan.form.totalStt")), 1),
            _createVNode("p", _hoisted_14, _toDisplayString(_ctx.totalSTT), 1)
          ]),
          _createVNode("div", null, [
            _createVNode("p", _hoisted_15, _toDisplayString(_ctx.$t("tagihan.form.totalTariff")), 1),
            _createVNode("p", _hoisted_16, _toDisplayString(_ctx.formatCurrency(_ctx.totalTariff)), 1)
          ]),
          _createVNode("div", null, [
            _createVNode("p", _hoisted_17, _toDisplayString(_ctx.$t("tagihan.form.totalAmount")), 1),
            _createVNode("p", _hoisted_18, _toDisplayString(_ctx.formatCurrency(_ctx.totalAmount)), 1)
          ]),
          _createVNode("div", null, [
            _createVNode("p", _hoisted_19, _toDisplayString(_ctx.$t("tagihan.form.billedTo")), 1),
            _createVNode(_component_Select, {
              onOpenSelect: _ctx.onOpenSortNameType,
              onCloseSelect: _ctx.onCloseSelectSortNameType,
              isOpenMenu: _ctx.isOpenSortNameType,
              value: _ctx.recipieValue,
              onChooseSelect: _ctx.onSelectSortNameType,
              dataSelect: _ctx.recipientNameData,
              customClass: "w-full"
            }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_20, [
        _createVNode("div", _hoisted_21, [
          _createVNode("label", _hoisted_22, [
            _createTextVNode(_toDisplayString(_ctx.$t("tagihan.form.note")) + " ", 1),
            _createVNode("span", _hoisted_23, _toDisplayString(_ctx.$t("tagihan.form.optional")), 1)
          ]),
          _withDirectives(_createVNode("textarea", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.note = $event)),
            rows: 4,
            placeholder: _ctx.$t('tagihan.form.notePlaceholder'),
            class: "w-full border border-gray-300 rounded-lg px-4 py-3 text-sm  placeholder-gray-400 focus:outline-none focus:ring-2  focus:ring-gray-300 resize-none",
            maxlength: 255
          }, null, 8, ["placeholder"]), [
            [_vModelText, _ctx.note]
          ])
        ]),
        _createVNode(_component_InvoiceRecipientTagPicker, {
          modelValue: _ctx.recipientTags,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.recipientTags = $event)),
          label: _ctx.$t('tagihan.form.sendTo'),
          isOptional: true
        }, null, 8, ["modelValue", "label"])
      ]),
      _createVNode(_component_TableBillDetail, {
        column: _ctx.column,
        tableData: _ctx.paginatedShipments,
        pagination: _ctx.pagination,
        startIndex: _ctx.startIndex,
        onSetPage: _ctx.onPageChange
      }, {
        sttNo: _withCtx(({ data }) => [
          _createVNode("div", _hoisted_24, [
            _createVNode("div", _hoisted_25, [
              _createVNode("span", _hoisted_26, _toDisplayString(data.sttNo), 1),
              (data.isCod && !data.isDfod)
                ? (_openBlock(), _createBlock("img", _hoisted_27))
                : _createCommentVNode("", true),
              (data.isCod && data.isDfod)
                ? (_openBlock(), _createBlock("img", _hoisted_28))
                : _createCommentVNode("", true)
            ]),
            _createVNode("span", _hoisted_29, _toDisplayString(data.shipmentId), 1)
          ])
        ]),
        recipientName: _withCtx(({ data }) => [
          _createVNode("div", _hoisted_30, [
            _createVNode("span", _hoisted_31, _toDisplayString(data.recipientName), 1),
            _createVNode("span", _hoisted_32, _toDisplayString(data.recipientPhoneMasked), 1)
          ])
        ]),
        productType: _withCtx(({ data }) => [
          _createVNode("div", _hoisted_33, [
            _createVNode("span", _hoisted_34, _toDisplayString(data.productType), 1),
            _createVNode("span", _hoisted_35, _toDisplayString(data.chargeableWeight ? `${data.chargeableWeight} kg` : "-"), 1)
          ])
        ]),
        tariff: _withCtx(({ data }) => [
          _createVNode("div", _hoisted_36, [
            (data.tariff)
              ? (_openBlock(), _createBlock("span", _hoisted_37, _toDisplayString(_ctx.formatCurrency(data.tariff)), 1))
              : _createCommentVNode("", true),
            (data.isCashless)
              ? (_openBlock(), _createBlock("span", _hoisted_38, "Cashless"))
              : _createCommentVNode("", true)
          ])
        ]),
        amount: _withCtx(({ data }) => [
          (data.paymentLabel === 'paid_by_recipient')
            ? (_openBlock(), _createBlock("span", _hoisted_39, _toDisplayString(_ctx.$t("tagihan.table.paidByRecipient")), 1))
            : (data.paymentLabel === 'paid_via_app')
              ? (_openBlock(), _createBlock("span", _hoisted_40, _toDisplayString(_ctx.$t("tagihan.table.paidViaApp")), 1))
              : (_openBlock(), _createBlock("span", _hoisted_41, _toDisplayString(_ctx.formatCurrency(data.amount)), 1))
        ]),
        action: _withCtx(({ data }) => [
          _createVNode("button", {
            onClick: ($event: any) => (_ctx.onDeleteShipment(data.sttNo))
          }, [
            _hoisted_42
          ], 8, ["onClick"])
        ]),
        _: 1
      }, 8, ["column", "tableData", "pagination", "startIndex", "onSetPage"])
    ]),
    (_ctx.isSuccessCreateInvoice)
      ? (_openBlock(), _createBlock(_component_ModalSuccessReceipt, {
          key: 0,
          visible: _ctx.isSuccessCreateInvoice,
          "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (_ctx.isSuccessCreateInvoice = $event)),
          mode: "create",
          invoiceData: _ctx.successCreateInvoiceData,
          onClose: _ctx.onCloseSuccessCreateInvoice,
          onDownload: _ctx.handleDownloadCreateInvoice
        }, null, 8, ["visible", "invoiceData", "onClose", "onDownload"]))
      : _createCommentVNode("", true),
    _createVNode(_component_InvoicePdfStruk, {
      ref: "struk",
      invoiceData: _ctx.invoiceDetail.header,
      items: _ctx.invoiceDetail.items
    }, null, 8, ["invoiceData", "items"]),
    _createVNode(_component_InvoicePdfA4, {
      ref: "invoice",
      invoiceData: _ctx.invoiceDetail.header,
      items: _ctx.invoiceDetail.items
    }, null, 8, ["invoiceData", "items"])
  ], 64))
}